import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Box from "@mui/joy/Box";
import { ListItem } from "@mui/joy";
import'./ministries.css';
import ChildrensMinistry from '../../assets/ChildrensMinistry.jpg'
import WomensMinistry from '../../assets/WomensMinistry.png'
import PrayerCommunity from '../../assets/PrayerCommunity.jpg'
import KingsHomeGroup from '../../assets/KingsHomeGroup.jpg'

const Ministries = () => {
    return (
        <Box className="App-header" sx={{backgroundColor: '#006494'}}>
                <Box className='pastor-container' sx={{backgroundColor:'white', padding: 6}}>
                <Stack sx={{marginTop: 10}} direction='row' spacing={4}>
                    <Stack className='pastor-column' spacing={2}>
                        <Typography level='h1'>
                            Women's Ministry
                        </Typography>
                        <Typography level='title-md'>
                            Mission
                        </Typography>
                        <Typography level='body-md'>
                            NHV Women gather regularly throughout the year to grow stronger in our relationships with each
                            other and encourage each other in drawing closer to the Lord. This is a warm and inviting circle of
                            women of all ages and walks of life, who are all passionate about Jesus. We enjoy every opportunity
                            to add new friends into our group.
                        </Typography>
                        <Typography level='title-md'>
                            Tuesday Evenings
                        </Typography>
                        <Typography level='body-md'>
                            We meet at the church on Tuesday nights from 7:00-8:30 pm for Bible study and to pray for one
                            another. Childcare is available upon request.
                        </Typography>
                        <Typography level='title-md'>
                            Monthly Luncheons
                        </Typography>
                        <Typography level='body-md'>
                            Every second Sunday of the month, immediately following the morning service, we gather for a
                            potluck luncheon. It's a special time of sharing delicious food, enjoying each other's company, and
                            nurturing our faith through a brief devotional. Everyone is invited—bring a dish if you can and enjoy
                            this time of community and connection!
                        </Typography>
                    </Stack>
                        <img className='pastor-image' src={WomensMinistry} alt="Women's Minitstry"/>
                </Stack>
                    <Stack sx={{marginTop: 10}} direction='row' spacing={4}>
                        <Stack className='pastor-column' spacing={2}>
                            <Typography level='h1'>
                                King's Home Group
                            </Typography>
                            <Typography level='title-md'>
                                Mission
                            </Typography>
                            <Typography level='body-md'>
                                Join us to experience the joy and growth that come from genuine fellowship
                                with your church family. Our goal is to build deeper connections, encourage
                                one another, and strengthen our collective journey with Christ in a
                                welcoming and relaxed atmosphere.
                            </Typography>
                            <Typography level='title-md'>
                                Friday Evenings
                            </Typography>
                            <Typography level='body-md'>
                                We gather twice monthly on Friday evenings at the King's home. On the first
                                Friday of each month, we enjoy a meaningful time watching and discussing
                                the series The Chosen, exploring its powerful portrayal of Jesus' life and
                                ministry. The third Friday of the month is dedicated to fun and fellowship
                                with our lively game nights. Everyone is welcome—come ready to enjoy
                                great company, engaging conversations, and plenty of laughter!
                            </Typography>
                        </Stack>
                            <img className='pastor-image' src={KingsHomeGroup} alt='King Home Group'/>      
                    </Stack>
                    <Stack sx={{marginTop: 10}} direction='row' spacing={4}>
                        <Stack className='pastor-column' spacing={2}>
                            <Typography level='h1'>
                                Prayer Community
                            </Typography>
                            <Typography level='title-md'>
                                Mission
                            </Typography>
                            <Typography level='body-md'>
                                The NHV Prayer Community seeks to foster a culture of transformation by empowering individuals and our church family through intentional prayer. 
                                We strive to deepen our relationship with God and enrich our spiritual growth, both individually and collectively.
                            </Typography>
                            <Typography level='title-md'>
                                What We Do
                            </Typography>
                            <ul>
                                <li>
                                    <Typography level='body-md'>
                                        <Typography level='title-md'>Monthly Gatherings: </Typography>
                                        We meet the third Sunday of every month at the church after the service,
                                        typically 12:30-2pm. We discuss new (and ancient) ways to discern God’s voice and practice
                                        spiritual exercises that enrich our prayer life.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography level='body-md'>
                                        <Typography level='title-md'>Intercessory Prayer: </Typography>
                                        We faithfully lift up the needs congregants share through prayer cards.
                                        Confidentiality is a cornerstone of our ministry, ensuring trust and privacy.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography level='body-md'>
                                        <Typography level='title-md'>Prayer Ministry: </Typography>
                                        We actively provide prayer support during church services and transformational
                                        prayer at other times of need, offering compassionate and confidential ministry.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography level='body-md'>
                                        <Typography level='title-md'>Trainings: </Typography>
                                        We host training sessions to empower those interested in prayer ministry, helping
                                        them grow in confidence and effectiveness in praying for others.
                                    </Typography>
                                </li>
                            </ul>
                        </Stack>
                            <img className='pastor-image' src={PrayerCommunity} alt='King Home Group'/>      
                    </Stack>
                    <Stack sx={{marginTop: 10}} direction='row' spacing={4}>
                        <Stack className='pastor-column' spacing={2}>
                            <Typography level='h1'>
                                Children's Ministry
                            </Typography>
                            <Typography level='title-md'>
                                Mission
                            </Typography>
                            <Typography level='body-md'>
                                Our children’s ministry exists to help kids grow in their faith, experience God’s love, and understand
                                His redemptive story. We aim to create a nurturing environment where they can build a strong
                                foundation in Christ. 
                            </Typography>
                            <Typography level='title-md'>
                                What to Expect
                            </Typography>
                            <Typography level='body-md'>
                                During the sermon, we provide a safe and engaging space for children through elementary school to
                                learn about God’s Word using The Gospel Project curriculum. Through age-appropriate Bible stories,
                                activities, and discussion, they discover how all of Scripture points to Jesus. We also provide loving
                                care for infants and toddlers in our nursery. 
                            </Typography>
                        </Stack>
                            <img className='pastor-image' src={ChildrensMinistry} alt='King Home Group'/>      
                    </Stack>
            </Box>
        </Box>
        
    );
};

export default Ministries;